import React from 'react';
import MainLayout from '../main/MainLayout';
import '../../assets/scss/app.scss';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createBrowserHistory } from "history";
import configuration from '../../configuration';

export const history = createBrowserHistory();

class App extends React.Component {

    render() {
        console.log(configuration);
        return (
            <BrowserRouter>
                <Routes>
                    <Route path={configuration.API_CONTEXT_ROOT + "/html/realtime/grid"} element={<MainLayout grid={true} selectedTab="0" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/html/realtime/graph"} element={<MainLayout grid={false} selectedTab="0" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/html/historic/"} element={<MainLayout selectedTab="1" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/html/forecast/"} element={<MainLayout selectedTab="2" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/html/realtime/"} element={<MainLayout grid={false} selectedTab="0" />} />
                    <Route path={configuration.API_CONTEXT_ROOT + "/html"} element={<MainLayout grid={false} selectedTab="0" />}  />
                    <Route path={configuration.API_CONTEXT_ROOT +"/atc/historic/"} element={<MainLayout selectedTab="1" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/atc/forecast/"} element={<MainLayout selectedTab="2" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/atc/realtime/grid/"} element={<MainLayout grid={true} selectedTab="0" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/atc/realtime/graph/"} element={<MainLayout grid={false} selectedTab="0" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/atc/realtime/"} element={<MainLayout grid={false} selectedTab="0" />} />
                    <Route path={configuration.API_CONTEXT_ROOT +"/atc"} element={<MainLayout grid={false} selectedTab="0" />}/>
                    <Route element={<MainLayout selectedTab="3" />}  />
                </Routes>
            </BrowserRouter>
        );
    }
}

export default App;